import * as React from 'react'

const MOBILE_BREAKPOINT = 768

/**
 * Returns true while the viewport is narrower than `breakpoint`.
 * Use only when the two viewports need genuinely different components
 * (e.g. a resizable split view vs a stacked one); prefer CSS breakpoints for styling.
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < breakpoint)
    return () => mql.removeEventListener('change', onChange)
  }, [breakpoint])

  return !!isMobile
}
